import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function useAuthGuard() {
    const { auth, logout, isAuthenticated, loadingAuth } = useAuth();
    const [openLoginModal, setOpenLoginModal] = useState(false);
    const [reloadLoading, setReloadLoading] = useState(false);

    useEffect(() => {
        auth();
    }, []);

    useEffect(() => {
        if (!loadingAuth) {
        if (!isAuthenticated) {
            setOpenLoginModal(true);
        } else {
            setOpenLoginModal(false);
        }
        }
    }, [isAuthenticated, loadingAuth]);

    const onSuccessLogin = async () => {
        setOpenLoginModal(false);
        setReloadLoading(true);
        await auth();
        setReloadLoading(false);
    };

    return {
        openLoginModal,
        setOpenLoginModal,
        onSuccessLogin,
        isAuthenticated,
        logout,
    };
}
